import { SvgBlockchainIcons } from '../blockchain/index.es.js';
import { SvgTokenIcons } from './index.es.js';

const TokenIconNameAliases = {
    SONIC: SvgTokenIcons.S,
    WORLDCHAIN: SvgTokenIcons.WLD,
    CODEX: SvgBlockchainIcons['Blockchain/Codex'],
    POLY: SvgTokenIcons.POL,
    MATIC: SvgTokenIcons.POL,
    MONAD: SvgTokenIcons.MON,
    HYPEREVM: SvgTokenIcons.HYPE
};

export { TokenIconNameAliases };
//# sourceMappingURL=aliases.es.js.map
